import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import jQuery from 'jquery';
import ProductInput from './main';
import { createRoot } from 'react-dom/client';
import { GetCommonSettings, GetExtraProducts, GetProductData } from '@themes/common/data';
import AppProvider from '@components/Shared/State/provider';
import SbThemeProvider from '@components/theme/provider';
export default function LoadProductInput(element) {
    const input = jQuery(element).parent('form').find('[name=id]');
    const id = input.val();
    const settings = GetCommonSettings();
    const product = GetProductData(id);
    if (!product) {
        return;
    }
    const extraProducts = GetExtraProducts(id);
    const rootDom = createRoot(element);
    let quantity = parseInt(product.metafields['SB-P']['MinimumQuantity'] || '1', 10);
    if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
    }
    rootDom.render(_jsx(AppProvider, { children: _jsx(SbThemeProvider, { children: _jsx(ProductInput, { id: product.variant_id, settings: settings, product: product, extraProducts: extraProducts, variantInput: input, quantity: quantity, minimumQuantity: quantity }) }) }));
}
